// noinspection JSUnusedGlobalSymbols
import { createRoot } from 'react-dom/client';
import { createElement } from '@wordpress/element';
import PageWrapper from './src/index';
import './src/scss/style.scss';
window.addEventListener('load', function () {
    var data = document.querySelector('#marqueex-admin-page');
    if (data) {
        createRoot(data).render(createElement(PageWrapper));
    }
});
